export class MilprReport {
    startDate: string;
    endDate: string;
    learners: MilprLearner[];
}

export class MilprLearner {
    placementId: number;
    studentId: number;
    studentFirstName: string;
    studentLastName: string;
    clientId: number | null;
    clientName: string;
    tutorName: string;
    subject: string;
    isGroup: boolean;
    groupName: string;
    ilps: MilprIlp[];
    progressReports: MilprProgressReport[];
    sessions: MilprSession[];
}

export class MilprIlp {
    placementId: number;
    studentId: number;
    baselineDate: string | null;
    individualLearningPlan: string;
    targetDescription: string;
    tutorInitialAssessment: string;
    learnerComments: string;
    assessmentUsed: string;
    assessmentScore: number | null;
    assessmentCaptureDate: string | null;
    targetForOutcome: number | null;
    confidenceRating: number | null;
    resilienceRating: number | null;
    independenceRating: number | null;
    motivationRating: number | null;
    selfRegulationRating: number | null;
    areasOfStrength: string;
    areasForDevelopment: string;
    targetKeyStageCode: string;
    targetGradeDescription: string;
    initialKeyStageCode: string;
    initialGradeDescription: string;
}

export class MilprProgressReport {
    placementId: number;
    studentId: number;
    reportDate: string;
    assessmentScore: number | null;
    confidenceRating: number | null;
    resilienceRating: number | null;
    independenceRating: number | null;
    motivationRating: number | null;
    selfRegulationRating: number | null;
    last6WeeksSummary: string;
    next6WeeksPlan: string;
}

export class MilprSession {
    placementId: number;
    studentId: number;
    startDate: string;
    startTime: string | null;
    endTime: string | null;
    attendance: string;
    reason: string;
    subject: string;
    sessionDelivery: string;
    engagement: number | null;
    comprehension: number | null;
    learningComment: string;
    engagementComment: string;
    learningObjective1: string;
    learningObjective2: string;
    learningObjective3: string;
    status: string;             // Submitted | Approved | Rejected
}
